import { Link, useParams } from "react-router-dom";

export default function GameBreadcrumb({ quizId }) {
  const { game, level, role, set } = useParams();

  const levelName = sessionStorage.getItem("levelName") || `Level ${level}`;

  const base = "/game-management";

  const crumbs = [
    {
      label: formatText(game),
      path: `${base}/${game}`,
    },
    level && {
      label: levelName,
      path: `${base}/${game}/${level}`,
    },
    role && {
      label: `Sets for ${formatText(role)}`,
      path: `${base}/${game}/${level}/${role}`,
    },
    set && {
      label: quizId || set,
    },
  ].filter(Boolean);

  return (
    <nav className="breadcrumb_nav">
      <ul className="breadcrumb mb-0">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <li
              key={index}
              className={`breadcrumb-item ${isLast ? "text-capitalize" : ""}`}
            >
              {isLast ? (
                crumb.label
              ) : (
                <Link to={crumb.path}>{crumb.label}</Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

function formatText(value = "") {
  return value.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
